const apiPath = {
  // auth
  login: "login",
  signup: "signup",
  forgot: "forget-password",
  verifyOtpForgotPassword: "verify-otp-forgot-password",
  resetPassword: "reset-password",
  accouniInfo: "admin/users/getProfile",
  updateProfile: "admin/users/profileUpdate",
  passportVerify: "passport-verify",

  // Property
  properties: "properties",
  propertyList: "properties-list",
  propertyDetail: "property",
  addToCart: "cart/add",
  removeCart: "cart/remove",
  cartList: "cart",
  bookmarkProperty: "bookmark-property",
  getBookmarkProperty: "get-bookmarked-property",

  // Order
  getPaymentInfo: "order/get-payment-info",
  walletPaymentOrder: "order/wallet-payment-order",
  createPaymentIntent: "order/create-payment-intent",
  createBankPayment: "order/create-bank-transfer-payment-order",

  // Profile
  verifyEmail: "verify-email",
  verifyOtpEmail: "verify-otp-email",
  updatePassword: "admin/users/changePassword",
  loginHistory: "admin/users/loginHistory",

  // Wallet
  createPaymentIntentWallet: "create-payment-intent-wallet",
  createWithdrawalRequest: "create-withdrawal-request",
  walletHistory: "wallet-history",

  // Portfolio
  getPortfolio: "portfolio",

  //Common
  getAllCountries: "get-all-countries",
  getPropertyTypes: "get-all-property-types",
  contactUs: "contact-us",

  // Bank
  getBankTransferRequests: "request/bank-transfer-requests",
};
export default apiPath;
